export var RoleConstants;
(function (RoleConstants) {
    RoleConstants["AdminRole"] = "Admin";
    RoleConstants["SupportAdminRole"] = "SupportAdmin";
    RoleConstants["BillingAdminRole"] = "BillingAdmin";
    RoleConstants["VendorRole"] = "Vendor";
    RoleConstants["SyncVendorRole"] = "SyncVendor";
    RoleConstants["ReviewVendorRole"] = "ReviewVendor";
    RoleConstants["ConceptManagerRole"] = "ConceptManager";
    RoleConstants["FranchiseConsultantRole"] = "FranchiseConsultant";
    RoleConstants["BrokerRole"] = "Broker";
    RoleConstants["FranchiseeRole"] = "Franchisee";
    RoleConstants["FranchiseeEmployeeRole"] = "FranchiseeEmployee";
    RoleConstants["GiftCertificateRedeemerRole"] = "GiftCertificateRedeemer";
    RoleConstants["GiftCertificateReimburserRole"] = "GiftCertificateReimburserRole";
    RoleConstants["MerchantAdminRole"] = "MerchantAdmin";
    RoleConstants["GiftCertificateAdminRole"] = "GiftCertificateAdmin";
    RoleConstants["MsMollyDonationAdminRole"] = "MsMollyDonationAdmin";
    RoleConstants["ProcessorAutomatonRole"] = "ProcessorAutomaton";
    RoleConstants["CCARole"] = "CCA";
    RoleConstants["CollectionsManagerRole"] = "CollectionsManager";
    RoleConstants["PresidentVPRole"] = "President";
    RoleConstants["LegalRole"] = "Legal";
    RoleConstants["DirectorOfComplianceRole"] = "DirectorOfCompliance";
    RoleConstants["RBWCertificationAdmin"] = "RBWCertificationAdmin";
    RoleConstants["HelpDeskRole"] = "HelpDesk";
    RoleConstants["GbBISReaderRole"] = "GbBISReader";
    RoleConstants["FranchiseCSR"] = "FranchiseCSR";
    RoleConstants["ZorWareZeeMailAdminRole"] = "ZorWareZeeMailAdmin";
    RoleConstants["BroadlyFeedUser"] = "BroadlyFeedUser";
    RoleConstants["BoomiUserRole"] = "BoomiUser";
    RoleConstants["FddManagementAdminRole"] = "FddManagementAdmin";
    RoleConstants["FddManagementReadOnlyRole"] = "FddManagementReadOnly";
    RoleConstants["ConceptRoyaltyAdminRole"] = "ConceptRoyaltyAdmin";
    RoleConstants["ConceptRoyaltyReadOnlyRole"] = "ConceptRoyaltyReadOnly";
    RoleConstants["FranchisorManagementAdminRole"] = "FranchisorManagementAdmin";
    RoleConstants["FranchisorManagementReadOnlyRole"] = "FranchisorManagementReadOnly";
    RoleConstants["FranchiseeManagementAdminRole"] = "FranchiseeManagementAdmin";
    RoleConstants["FranchiseeManagementReadOnlyRole"] = "FranchiseeManagementReadOnly";
    RoleConstants["ContractManagementAdminRole"] = "ContractManagementAdmin";
    RoleConstants["ContractManagementReadOnlyRole"] = "ContractManagementReadOnly";
    RoleConstants["BatchManagementAdminRole"] = "BatchManagementAdmin";
    RoleConstants["BatchManagementReadOnlyRole"] = "BatchManagementReadOnly";
    RoleConstants["PeriodReportAdminRole"] = "PeriodReportAdmin";
    RoleConstants["PeriodReportReadOnlyRole"] = "PeriodReportReadOnly";
    RoleConstants["TaxReturnAdminRole"] = "TaxReturnAdmin";
    RoleConstants["TaxReturnReadOnlyRole"] = "TaxReturnReadOnly";
    RoleConstants["RoyaltyFranchiseEntityAdminRole"] = "RoyaltyFranchiseEntityAdmin";
    RoleConstants["RoyaltyFranchiseEntityReadOnlyRole"] = "RoyaltyFranchiseEntityReadOnly";
    RoleConstants["RmsManualSalesAdminRole"] = "RmsManualSalesAdmin";
    RoleConstants["CallCenterAdmin"] = "CallCenterAdmin";
    RoleConstants["CallCenterVendorAdmin"] = "CallCenterVendorAdmin";
    RoleConstants["CallCenterVendorSuperUser"] = "CallCenterVendorSuperUser";
    RoleConstants["CallCenterVendorUser"] = "CallCenterVendorUser";
    RoleConstants["CallCenterAcknowledgeCallUser"] = "CallCenterAcknowledgeCallUser";
    RoleConstants["KnowledgeBaseContributor"] = "KnowledgeBaseContributor";
    RoleConstants["KnowledgeBaseAdmin"] = "KnowledgeBaseAdmin";
    RoleConstants["DigitalReadOnly"] = "DigitalReadOnly";
    RoleConstants["LMSAdmin"] = "LMSAdmin";
    RoleConstants["DigitalAdmin"] = "DigitalAdmin";
    RoleConstants["LMSReadOnly"] = "LMSReadOnly";
    RoleConstants["CRMReadOnly"] = "CRMReadOnly";
    RoleConstants["DigitalOps"] = "DigitalOps";
    RoleConstants["NBLYHUB"] = "NBLYHUB";
})(RoleConstants || (RoleConstants = {}));
